// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"8e54ebab","174":"f8abafc6","453":"21a32f7d"}[chunkId] + ".chunk.js";
};